import { resolveCourseNodeIdFromConnector } from 'utils/program/training'
import { doesLessonNodeMatch } from 'utils/lms/lessonNodeHelpers'

const resolveCourseNodeConnectorFromSummary = summary => {
  if (summary?.courseNodeConnector) return summary.courseNodeConnector
  if (summary?.course_node_connector) return summary.course_node_connector

  if (!Array.isArray(summary?.metadata)) return null

  return (
    summary.metadata.find(entry => entry?.courseNodeConnector)
      ?.courseNodeConnector ||
    summary.metadata.find(entry => entry?.course_node_connector)
      ?.course_node_connector ||
    null
  )
}

/**
 * Resolves the LMS course-node identifier for a unit link summary.
 * Curriculum-service Summary sections may expose the connector on the summary,
 * inside metadata, or only as the summary `id` (Contentful entry id).
 */
export const resolveCourseNodeEntryPointFromSummary = summary => {
  const connector = resolveCourseNodeConnectorFromSummary(summary)

  return (
    resolveCourseNodeIdFromConnector(connector) ||
    summary?.id ||
    summary?.sys?.id ||
    null
  )
}

export const isLessonNodeCompleteForSummary = ({
  lessonNode,
  courseNodeEntryPoint,
  mappedLeafNodeId,
  indexLeafNodeId,
}) => {
  if (!lessonNode?.is_done) return false

  if (indexLeafNodeId && lessonNode.leaf_node_id === indexLeafNodeId) {
    return true
  }

  if (mappedLeafNodeId && lessonNode.leaf_node_id === mappedLeafNodeId) {
    return true
  }

  if (
    courseNodeEntryPoint &&
    doesLessonNodeMatch(lessonNode, courseNodeEntryPoint)
  ) {
    return true
  }

  return false
}
